import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { InputGroup, Modal, Button, Form, Col, Row } from "react-bootstrap";
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CreateToDoListModal = ({ show, close }) => {

  // login userdata
  const loginUserData = useSelector((state) => state?.loginData?.userData);

  // usestate
  const [tasktitle, setTaskTitle] = useState("");
  const [taskdesc, setTaskDesc] = useState("");

  // for error msg
  const [errors, setErrors] = useState({
    title: "",
    description: ""
  })

  const validate = () => {
    let tempErrors = {
      title: "",
      description: ""
    }

    let isValid = true;

    if (!tasktitle.trim()) {
      tempErrors.title = "Title is required";
      isValid = false;
    }

    if (!taskdesc.trim()) {
      tempErrors.description = "Description is required";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  }

  const handlerAddToDoData = async () => {
    if (!validate()) return;
    const payload = {
      "title": tasktitle,
      "description": taskdesc,
      "empId": loginUserData?.empId
    }
    await axios.post(process.env.REACT_APP_BASE_URL + "/toDoList/addToDoList", payload)
      .then((res) => {
        if (res.data.message === "Added Successfully") {
          toast.success("Added Successfully", {
            toastId: "add-todo-success"
          });
          setTaskTitle("")
          setTaskDesc("")
        }
        close();
      })
      .catch((err) => {
        console.log("Error:", err)
      })
  }


  return (
    <>
      <Modal show={show} onHide={close} size="md" centered backdrop='static' keyboard={false}>
        <Modal.Header closeButton className="mngmodelheader">
          <Modal.Title><h5>Create List</h5></Modal.Title>
        </Modal.Header>
        <Modal.Body size="lg">
          <Row className='mb-3'>
            <Col sm={12} md={12}>
              <InputGroup>
                <Form.Control
                  placeholder="Title"
                  className="input-field project-inputgroup"
                  name="title"
                  value={tasktitle}
                  onChange={(e) => setTaskTitle(e.target.value)}
                />
              </InputGroup>
              {errors.title && <p style={{ color: "red", fontSize: "12px", marginTop: '2px' }}>{errors.title}</p>}
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12}>
              <InputGroup>
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder="Write the description of task..."
                  className="input-field project-inputgroup"
                  name="description"
                  value={taskdesc}
                  onChange={(e) => setTaskDesc(e.target.value)}
                />
              </InputGroup>
              {errors.description && <p style={{ color: "red", fontSize: "12px", marginTop: '2px' }}>{errors.description}</p>}
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className="text-center mt-4">
          {/* <Button className="primaryBtn ">Assign</Button> */}
          <Button className="activeBtn" onClick={() => { handlerAddToDoData() }}>Save</Button>
        </Modal.Footer>
      </Modal>
    </>

  )
}

export default CreateToDoListModal